import {IPolyBetLineConfig, PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline} from "gsap";
import {BookOfShadowsGameConfig} from "../BookOfShadowsGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class BookOfShadowsBetLine extends PolyBetLine {
    private _anim: TimelineSprite;
    private _animTl: Timeline;

    /**
     * @inheritDoc
     * @param numberPosition
     * @param betLineData
     * @param config
     */
    protected draw(numberPosition: number[], betLineData: number[], config: IPolyBetLineConfig): void {
        let item: PIXI.Sprite = new PIXI.Sprite(),
            animItem: TimelineSprite = new TimelineSprite([PIXI.Texture.EMPTY]),
            name: string = "betlines/Betline_",
            animFolderName: string = "betlines/",
            animName: string = "BetLineAnimation",
            offsetY: number = 0,
            offsetX: number = -10,
            xPos: number = BookOfShadowsGameConfig.instance.REEL_AREA_POS_X,
            yPos: number = Helper.getSymbolPositions(0, betLineData[0])[1];

        const symHeight: number = BookOfShadowsGameConfig.instance.SYMBOL_HEIGHT;

        switch (this.index) {
            case 1:
            case 2:
            case 3:
            case 11:
            case 16:
                name = name + "1";
                animName = "betlines/BetLineAnimation/BetlineAnimation_";

                offsetX = -30;
                break;
            case 4:
            case 12:
            case 17:
                name = name + "20";
                animName = animFolderName + animName + "20/" + animName + "20_";
                item.scale.y *= -1;
                animItem.scale.y *= -1;

                offsetY = symHeight;
                break;
            case 5:
            case 13:
            case 18:
                name = name + "20";
                animName = animFolderName + animName + "20/" + animName + "20_";

                offsetY = -symHeight;
                break;
            case 6:
            case 7:
            case 14:
            case 19:
                name = name + "8";
                animName = animFolderName + animName + "8/" + animName + "8_";

                offsetY = symHeight / 2;
                break;
            case 8:
            case 9:
            case 15:
            case 20:
                name = name + "8";
                animName = animFolderName + animName + "8/" + animName + "8_";
                item.scale.y *= -1;
                animItem.scale.y *= -1;

                offsetY = -(symHeight / 4);
                break;
            case 10:
                name += "10";
                animName = animFolderName + animName + "10/" + animName + "20_";

                offsetY = symHeight;
                break;
            default:
                break;
        }

        yPos += offsetY;
        xPos += offsetX;

        item.texture = GameResources.getTextures(name)[0];
        item.position.set(xPos, yPos);
        item.anchor.set(0, 0.5);
        this.addChild(item);

        (animItem as any)._textures = GameResources.getTextures(animName);
        animItem.anchor.set(0, 0.5);
        animItem.position.set(xPos, yPos);
        animItem.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(animItem);
        this._anim = animItem;

        this.alpha = 0;
        StageManager.getLayer(config.staticLineLayer).addChild(this);
    }

    /**
     * @inheritDoc
     */
    protected showWin(): void {
        super.showWin();

        this.killAnimTimeline();
        this._animTl = this._anim.getAnimationAutoShowHide(true, true);
    }

    /**
     * @inheritDoc
     */
    protected hideAll(): void {
        super.hideAll();
        this.killAnimTimeline();
    }

    /**
     * @description To kill the animation played on top of betLine.
     */
    private killAnimTimeline(): void {
        if (this._animTl && this._animTl.isActive()) {
            this._animTl.pause();
            this._animTl.kill();
        }
    }
}